import { render, staticRenderFns } from "./PrintAccountsPayableStatement.vue?vue&type=template&id=0b8a07d8&scoped=true"
import script from "./PrintAccountsPayableStatement.vue?vue&type=script&lang=js"
export * from "./PrintAccountsPayableStatement.vue?vue&type=script&lang=js"
import style0 from "./PrintAccountsPayableStatement.vue?vue&type=style&index=0&id=0b8a07d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a07d8",
  null
  
)

export default component.exports